


const IconCheck = ({ width = 20 }) => (
    <img width={width} src={require(`./iconCheck.svg`).default} alt="imagen" />
)

const IconWarning = ({ width = 20 }) => (
    <img width={width} src={require(`./iconWarning.png`).default} alt="imagen" />
)

const IconOk = ({ width = 20 }) => (
    <img width={width} src={require(`./iconOk.svg`).default} alt="imagen" />
)

const IconError = ({ width = 20 }) => (
    <img width={width} src={require(`./iconError.svg`).default} alt="imagen" />
)


const IconRigth = ({ width = 20 }) => (
    <img style={{width:'100%'}} src={require(`./iconRigth.png`).default} alt="imagen" />
)

const IconLeft = ({ width = 20 }) => (
    <img style={{width:'100%'}} src={require(`./iconLeft.png`).default} alt="imagen" />
)

const IconSave = ({ width = 20 }) => (
    <img style={{width:'100%'}} src={require(`./iconSave.png`).default} alt="imagen" />
)


const IconClear = ({ width = 20 }) => (
    <img style={{width:'100%'}} src={require(`./iconClear.png`).default} alt="imagen" />
)

const IconInfo = ({ width = 20 }) => (
    <img style={{width:'100%'}} src={require(`./iconInfo.png`).default} alt="imagen" />
)






export {
    IconCheck,
    IconWarning,
    IconOk,
    IconRigth,
    IconLeft,
    IconSave,
    IconClear,
    IconError,
    IconInfo
}